export default __webpack_public_path__ + "static/media/stars.521ba407.png";